module.exports = {"subnavLinks":[{"label":"Identificadores Ativação","link":"#","id":"profileActivation"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/TemplateProfileActivation/data.json
// module id = 2259
// module chunks = 0